import { bffApi } from "../../autogen/bff-api";

export const PROJECT_SUMMARY_TAGS = ["Project", "SourcingEvent", "Contract", "Product"] as const;

bffApi.enhanceEndpoints({
  endpoints: {
    getProjectProcurementSummary: { providesTags: [...PROJECT_SUMMARY_TAGS] },
  },
});
